import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";


// fetch pending payout
const fetchPendingPayout = async ({ page, limit, search }) => {
  const response = await api.get("/v1/admin/personal/pending-payouts", {
    params: { page, limit, ...(search && { search }) },
  });
  return response.data;
};

export const usePendingPayout = (page = 1, limit = 10, search = "") => {
  return useQuery({
    queryKey: ["pending-payout", page, limit, search],
    queryFn: () => fetchPendingPayout({ page, limit, search }),
    refetchOnWindowFocus: false,
  });
};

// retry pending payout
const retryPendingPayout = async (uuid) => {
  const { data } = await api.post(
    `/v1/admin/personal/retry-payout/${uuid}`
  );
  return data;
};

export const useRetryPendingPayout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: retryPendingPayout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pending-payout"] });
    },
  });
};

// decline payout
const declinePayout = async (payload) => {
  const { data } = await api.post(
    "/v1/admin/personal/decline-payout",
    payload
  );
  return data;
};

export const useDeclinePayout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: declinePayout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pending-payout"] });
    },
  });
};


// decline payout
const markPayoutSuccessful = async (payload) => {
  const { data } = await api.post(
    "/v1/admin/personal/mark-payout-successful",
    payload
  );
  return data;
};

export const useMarkPayoutSuccessful = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markPayoutSuccessful,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pending-payout"] });
    },
  });
};
